const PT = require("prop-types");
const React = require("react");
const createReactClass = require("create-react-class");
const AT = require("../vault/ActionTypes");
const withVaultDispatch = require("../hoc/withVaultDispatch");
const withVaultUpdate = require("../hoc/withVaultUpdate");

// Helper to apply higher-order components.
const augment = function(Component) {
	Component = withVaultDispatch(Component);
	Component = withVaultUpdate(Component, function(props, vaultState) {
		const user = (vaultState && vaultState.user) || {};
		const imitatorRoles = user.imitatorRoles || [];
		const hasIplOpsAdmin = imitatorRoles.indexOf("ipl-ops-admin") >= 0;
		return {
			userID: user.userID || 0,
			imitatorUserID: user.imitatorUserID || "",
			imitatorIdentifier: user.imitatorIdentifier ?? user.imitatorUserID,
			imitatorRoles,
			hasIplOpsAdmin,
			superUserModeAvailable: hasIplOpsAdmin,
		};
	});
	return Component;
};
module.exports = augment(
	createReactClass({
		displayName: "ImitatorIndicator",

		propTypes: {
			// Injected by HOCs
			userID: PT.number,
			imitatorUserID: PT.string,
			imitatorIdentifier: PT.string,
			imitatorRoles: PT.arrayOf(PT.string),
			hasIplOpsAdmin: PT.bool,
			superUserModeAvailable: PT.bool,
			dispatch: PT.func.isRequired,
		},

		getInitialState: function() {
			return {
				deniedAPIEndpoint: null,
				deniedAPIGeneration: 0,
				unimitateError: false,
				unimitateErrorGeneration: 0,
				superUserModeChecked: !!(
					typeof window !== "undefined" && window.superUserMode
				),
			};
		},

		// Used by vault update HOC
		vaultEvents: {
			noImitating: function(socketEvent) {
				const myGeneration = this.state.deniedAPIGeneration + 1;
				this.setState({
					deniedAPIEndpoint: socketEvent,
					deniedAPIGeneration: myGeneration,
				});
				this.deniedAPITimeout = setTimeout(() => {
					if (this.state.deniedAPIGeneration === myGeneration) {
						this.setState({deniedAPIEndpoint: null});
					}
				}, 10000);
			},
			unimitateFail: function() {
				const myGeneration = this.state.unimitateErrorGeneration + 1;
				this.setState({
					unimitateError: true,
					unimitateErrorGeneration: myGeneration,
				});
				this.unimitateErrorTimeout = setTimeout(() => {
					if (this.state.unimitateErrorGeneration === myGeneration) {
						this.setState({unimitateError: false});
					}
				}, 10000);
			},
		},

		componentWillUnmount: function() {
			clearTimeout(this.deniedAPITimeout);
			clearTimeout(this.unimitateErrorTimeout);
		},

		onUnimitate: function() {
			this.props.dispatch({
				type: AT.UNIMITATE_REQUEST,
				newURL: "/admin/accounts",
			});
		},

		onSuperUserModeChange: function(e) {
			window.superUserMode = e.target.checked;
			this.setState({superUserModeChecked: window.superUserMode});
		},

		render: function() {
			if (!this.props.imitatorUserID) {
				return null;
			}

			const hasIplOpsAdmin = this.props.hasIplOpsAdmin;
			const inSuperUserMode =
				this.props.superUserModeAvailable && this.state.superUserModeChecked;

			const containerStyle = {
				position: "fixed",
				left: 10,
				bottom: 10,
				padding: 5,
				zIndex: 1000000,
				border: inSuperUserMode ? "2px solid #e6b800" : "2px solid #dd1f2d",
				background: "#771016",
				color: "white",
				fontSize: "14px",
				lineHeight: "16px",
			};

			let superUserBanner = null;
			if (inSuperUserMode) {
				superUserBanner = (
					<div
						style={{
							background: "#e6b800",
							color: "#000",
							margin: "-5px -5px 5px -5px",
							padding: "4px 5px",
							fontWeight: "bold",
						}}
					>
						Bypassing Imitator Restrictions (Cool People Only)
					</div>
				);
			}

			let superUserCheckbox = null;
			if (hasIplOpsAdmin) {
				superUserCheckbox = (
					<div style={{marginTop: 6}}>
						<label style={{display: "flex", alignItems: "center", gap: 6}}>
							<input
								type="checkbox"
								checked={inSuperUserMode}
								onChange={this.onSuperUserModeChange}
							/>
							<span>Super User Mode</span>
						</label>
					</div>
				);
			}

			let deniedDiv = null;
			let unimitateErrorDiv = null;
			if (this.state.deniedAPIEndpoint) {
				deniedDiv = (
					<div>
						<strong>
							Request to {this.state.deniedAPIEndpoint}
							<br />
							is not available to imitators.
						</strong>
					</div>
				);
			}
			if (this.state.unimitateError) {
				unimitateErrorDiv = (
					<div>
						<strong>Unimitate failed. Try refreshing?</strong>
					</div>
				);
			}

			return (
				<div id="imitate_indicator" style={containerStyle}>
					{superUserBanner}
					You are imitating user ID <strong>{this.props.userID}</strong>.
					<br />
					You are actually user
					<strong> {this.props.imitatorIdentifier}</strong>
					.
					<br />
					This panel will tell you when
					<br />a request was denied to imitators.
					<div>
						<button onClick={this.onUnimitate}>Unimitate</button>
					</div>
					{superUserCheckbox}
					{deniedDiv}
					{unimitateErrorDiv}
				</div>
			);
		},
	})
);
